import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/chi-siamo", label: "Chi Siamo", testid: "nav-chi-siamo-link" },
  { to: "/calendario", label: "Calendario", testid: "nav-calendario-link" },
  { to: "/classifiche", label: "Classifiche e Live", testid: "nav-classifiche-link" },
  { to: "/squadre", label: "Squadre", testid: "nav-squadre-link" },
  { to: "/team", label: "Il Nostro Team", testid: "nav-team-link" },
  { to: "/partner", label: "Partner", testid: "nav-partner-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-night/90 backdrop-blur-md border-b border-line" data-testid="main-navbar">
      <div className="h-1 bg-gold" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src="/logo-crest.png" alt="Stemma Artemide FC" className="h-12 w-12 object-contain" />
          <img src="/logo-deer.png" alt="Marchio cervo Artemide FC" className="h-10 w-auto" />
          <span className="font-display font-800 text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-white leading-none">
            Artemide <span className="text-gold">FC</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `nav-link-bar font-display uppercase tracking-wider text-lg font-semibold transition-colors ${
                  isActive ? "text-gold active" : "text-zinc-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Apri menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-line bg-night px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`${l.testid}-mobile`}
              className={({ isActive }) =>
                `font-display uppercase tracking-wider text-xl font-semibold ${isActive ? "text-gold" : "text-zinc-300"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
